const contactEnglish = () => (
  {
    title: 'Get in touch',
    formText: 'Question, comment or concern? Drop a message in the form. I will be glad to hear from you.',
    fromInput: {
      name: 'Your name',
      mail: 'Email',
      message: 'Message',
    },
  }
);

export default contactEnglish;
